@import './pk-bottom-panel.variables';

:host {
  @apply z-[999] flex px-[--bottom-panel--desktop-padding];
}

.pk-bottom-panel {
  @include transition(#{bottom, visibility});
  @apply invisible fixed right-0 z-[1001] box-border flex w-full flex-col;
  @apply rounded-[--bottom-panel--border-radius] bg-[color:--bottom-panel--background] px-[--bottom-panel--padding-horizontal] py-[--bottom-panel--padding-vertical];
  @apply sm:right-[unset];

  font-family: var(--pk-font-base-regular);
  box-shadow: var(--bottom-panel--box-shadow);

  &.open {
    @apply visible;
    @apply bottom-0 #{!important};
  }

  &.close {
    @apply z-[-1] opacity-0;
  }

  &.small {
    @apply sm:w-[--bottom-panel--width-small];
  }

  &.medium {
    @apply sm:w-[--bottom-panel--width-medium];
  }

  &.large {
    @apply right-0;
    @media (min-width: 832px) {
      @apply right-[unset] w-[--bottom-panel--width-large];
    }
  }
}

.title {
  ::slotted(*) {
    @apply m-0 mb-s mr-xs p-0 text-l leading-m text-text-01;

    font-family: var(--pk-font-base-regular);
  }
}

.body {
  ::slotted(*) {
    @apply m-0 p-0 text-s leading-l text-text-02;

    font-family: var(--pk-font-base-regular);
  }
}

.pk-bottom-panel__overlay {
  @apply fixed left-0 top-0 z-[1001] h-screen w-screen opacity-100 transition-[opacity,z-index] duration-[25ms] ease-in-out;

  background-color: rgba(0, 0, 0, 0.3);

  &.hidden {
    @apply z-[-1] opacity-0;
  }
}
